module.exports = __webpack_public_path__ + "img/fire.aeb1a06d.svg";